<template>
	<header id="page-topbar">
		<div class="navbar-header">
			<div class="d-flex">
				<!-- LOGO -->
				<div class="navbar-brand-box text-center">
					<a href="/" class="logo logo-dark">
						<span class="logo-sm">
							<img src="https://getbase.s3.ap-southeast-1.amazonaws.com/Techventis+Medic+Sdn+Bhd.png" alt width="40%" />
						</span>
						<span class="logo-lg">
							<img src="https://getbase.s3.ap-southeast-1.amazonaws.com/Techventis+Medic+Sdn+Bhd.png" alt width="40%" />
						</span>
					</a>

					<a href="/" class="logo logo-light">
						<span class="logo-sm">
							<img src="https://getbase.s3.ap-southeast-1.amazonaws.com/Techventis+Medic+Sdn+Bhd.png" alt width="40%" />
						</span>
						<span class="logo-lg">
							<img src="https://getbase.s3.ap-southeast-1.amazonaws.com/Techventis+Medic+Sdn+Bhd.png" alt width="40%" />
						</span>
					</a>
				</div>

				<button @click="toggleMenu" type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn">
					<i class="ri-menu-2-line align-middle"></i>
				</button>
			</div>

			<div class="d-flex">
				<b-dropdown variant="white" right toggle-class="header-item">
					<template v-slot:button-content>
						<img
							class
							:src="current_language?.flag"
							alt="Header Language"
							height="16"
						/>
					</template>
					<b-dropdown-item
						class="notify-item"
						v-for="(entry, i) in languages"
						:key="`Lang${i}`"
						:value="entry"
						@click="setLanguage(entry)"
						:link-class="{ 'active': entry === current_language }"
					>
						<img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
						<span class="align-middle">{{ entry.title }}</span>
					</b-dropdown-item>
				</b-dropdown>
				<!-- <b-dropdown
					variant="white"
					right
					toggle-class="header-item"
				>
					<template v-slot:button-content>
						<div v-if="!current_company.value" style="height: 22px; width: 30px;">
							<i class='mdi mdi-domain d-xl-inline-block h4'></i> 
						</div>
						<img
							v-else
							:src="current_company.logoUrl"
							class="rounded-circle object-fit-cover"
							width="30"
							height="30"
							style="object-fit: cover; object-position: center;"
						/>
					</template>
					<b-dropdown-item
						v-for="(item, index) in companyDdl"
						class="notify-item"
						:key="index"
						:value="item.value"
						@click="setCompany(item)"
					>
						<img v-if="item.value" :src="item.logoUrl" class="rounded-circle object-fit-cover mr-2 ml-0 pl-0"  width="28" height="28" />
						<i v-else class='mdi mdi-domain d-xl-inline-block h4 mr-2'></i> 
						<span class="align-middle">{{ item.text }}</span>
					</b-dropdown-item>
				</b-dropdown> -->
				<b-dropdown v-if="user_type == 'ADMIN'" right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
					<template v-slot:button-content>
						<img class="rounded-circle header-profile-user"
							src="https://getbase.s3.ap-southeast-1.amazonaws.com/default_profile_image.jpg"
							alt="Header Avatar"
							style="margin: 5px;"
						/>
						<span class="d-none d-xl-inline-block ml-1">{{ name }}</span>
						<i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
					</template>
					<!-- item-->
					<a class="dropdown-item" href="/profile">
						<i class="ri-user-line align-middle mr-1"></i>
						{{ $t('module.profile') }}
					</a>
					<div class="dropdown-divider"></div>
					<a class="dropdown-item text-danger" href="/logout">
						<i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
						{{ $t('module.logout') }}
					</a>
				</b-dropdown>
				<b-dropdown v-else right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
					<template v-slot:button-content>
						<img class="rounded-circle header-profile-user" :src="user_image"
						alt="Header Avatar"
						style="margin: 5px;" />
						<span class="d-none d-xl-inline-block ml-1">{{ staffName }}</span>
						<!-- <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i> -->
					</template>
					<!-- item-->
					<a class="dropdown-item" href="/staff-profile">
						<i class="ri-user-line align-middle mr-1"></i>
						{{ $t('module.profile') }}
					</a>
					<div class="dropdown-divider"></div>
					<a class="dropdown-item text-danger" href="/staff-logout">
						<i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
						{{ $t('module.logout') }}
					</a>
				</b-dropdown>
				<!-- <b-dropdown v-if="user_type == 'ADMIN'" right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
					<template v-slot:button-content>
						<i class="mdi mdi-circle d-none d-xl-inline-block" style="color: lightgrey; font-size: 28px; margin: 5px"></i>
					</template>
					<div class="align-items-center d-flex ml-4">
						<span class="d-none d-xl-inline-block ml-1">{{ name }}</span>
					</div>
					<div class="dropdown-divider"></div>
					<a class="dropdown-item" href="#">
						Company 1
					</a>
					<a class="dropdown-item" href="#">
						Company 2
					</a>
					<a class="dropdown-item" href="#">
						Company 3
					</a>
					<a class="dropdown-item" href="#">
						Company 4
					</a>
					<a class="dropdown-item" href="#">
						All Companies
					</a>
				</b-dropdown> -->
			</div>
		</div>
	</header>
</template>
<script>
import i18n from "../i18n";
import { sessionHelper } from '@/utils'
import { lookupMethods, globalFilterMethods } from "@/state/helpers";

export default {
	data() {
		return {
			name: sessionHelper.getUserName(),
			staffName: sessionHelper.getStaffUserName(),
			user_type: sessionHelper.getUserType(),
			user_image: sessionHelper.getStaffUserImage(),
			company_name: sessionHelper.getStaffCompanyName(),
			company_uuid: sessionHelper.getStaffCompanyUUID(),
			location_name: sessionHelper.getStaffLocationName(),
			location_uuid: sessionHelper.getStaffLocationUUID(),
			languages: [
				{
					flag: require("@/assets/images/flags/us.jpg"),
					language: "en",
					title: "English"
				},
				{
					flag: require("@/assets/images/flags/chaina.png"),
					language: "zh",
					title: "Chinese"
				},
				{
					flag: require("@/assets/images/flags/melayu.png"),
					language: "ms",
					title: "Bahasa Melayu"
				},
			],
			current_language: null,
			current_group: {},
			groups: [],
		};
	},
	async created() {
		this.current_language = this.languages[0];
		this.current_group = sessionHelper.getCurrentGroup() ? JSON.parse(sessionHelper.getCurrentGroup()) : { value: 0, text: i18n.t('label.all'), logoUrl: null };
	},
	methods: {
		...lookupMethods,
		...globalFilterMethods,
		toggleMenu() {
			this.$parent.toggleMenu();
		},
		initFullScreen() {
			document.body.classList.toggle("fullscreen-enable");
			if (
				!document.fullscreenElement &&
				/* alternative standard method */ !document.mozFullScreenElement &&
				!document.webkitFullscreenElement
			) {
				// current working methods
				if (document.documentElement.requestFullscreen) {
					document.documentElement.requestFullscreen();
				} else if (document.documentElement.mozRequestFullScreen) {
					document.documentElement.mozRequestFullScreen();
				} else if (document.documentElement.webkitRequestFullscreen) {
					document.documentElement.webkitRequestFullscreen(
						Element.ALLOW_KEYBOARD_INPUT
					);
				}
			} else {
				if (document.cancelFullScreen) {
					document.cancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				}
			}
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar();
		},
		setLanguage(locale) {
			i18n.locale = locale.language;
			this.current_language = locale;
		},
		getGroupFilter() {
			if(this.groupDdl.length == 1) this.lookupGroup({ hasOptionAll: false });
		},
		setGroupFilter(item) {
			this.current_group = item;
			this.setGlobalFilter(JSON.stringify(item)); // value, text, photoUrl
			this.$refs.groupDropdown.hide();
		},
	},
	computed: {
		groupDdl() {
            return [
				{ value: 0, text: i18n.t('label.all'), photoUrl: null },
				...(this.$store.state.lookup.groupDdl || []),
			];
        },
	},
};
</script>
<style lang="scss" scoped>
	.notify-item {
		.active {
			color: #16181b;
			background-color: #f8f9fa;
		}
	}
</style>
<style scoped>
	.selected-text span {
		color: #007bff;
		/* Change text color to blue */
		font-weight: bold;
		/* Optional: make the text bold */
	}

	.group-dropdown-inner {
		max-height: 320px;
		overflow-y:auto; min-width:220px;
	}
	.group-row{
		display:flex; align-items:center;
		padding:.5rem; white-space:nowrap;
	}
</style>
